import { DraftActions, DraftV1Actions } from '../actions/actionTypes'
import { ReducerBuilder } from './ReducerBuilder'

const INITIAL_STATE = []

const setDraftPreview = (state: string[], payload: string[]): string[] => {
  return payload
}

const clearDraftPreview = (): string[] => {
  return []
}

const reducer = ReducerBuilder.create<string[], string[]>(INITIAL_STATE)
  .mapAction(DraftActions.PREVIEW_DRAFT, setDraftPreview)
  .mapAction(DraftV1Actions.DRAFT_V1_PREVIEW, setDraftPreview)
  .mapAction(DraftV1Actions.DRAFT_V1_CLEAR_PREVIEW, clearDraftPreview)
  .build()

export default reducer
